import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { TableConfig, DEFAULT_PAGE_SIZE } from "../../configs/constants";
import { UsersSearchRequest } from "../api-interfaces";

interface UserList {
  searchCriteria: UsersSearchRequest;
  tableConfig: TableConfig;
}

export const INITIAL_SEARCH_CRITERIA: UsersSearchRequest = {
  typeCode: "",
  companyName: "",
  email: "",
  name: "",
  deactivateFlag: "",
  memo: "",
  comment: "",
  permissionCode: "",
  timestamp: -1,
};

const initialState: UserList = {
  searchCriteria: INITIAL_SEARCH_CRITERIA,
  tableConfig: {
    pageSize: DEFAULT_PAGE_SIZE,
    pageIndex: 1,
    columnWidths: [],
  },
};

const userListSlice = createSlice({
  name: "userList",
  initialState,
  reducers: {
    setSearchCriteria: (state, action: PayloadAction<UsersSearchRequest>) => {
      state.searchCriteria = action.payload;
      state.tableConfig = {
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: 1,
        columnWidths: [],
      };
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageIndex = action.payload;
    },
    setColumnWidths: (state, action: PayloadAction<number[]>) => {
      state.tableConfig.columnWidths = action.payload;
    },
    changePageSize: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageSize = action.payload;
      state.tableConfig.pageIndex = 1;
    },
  },
});

export const {
  setSearchCriteria,
  setPageIndex,
  setColumnWidths,
  changePageSize,
} = userListSlice.actions;

export default userListSlice.reducer;
